import React from 'react';
import styles from './HowTo.module.css';
import { STEPS } from '../../data/steps';
import { LINKS } from '../../config/links';

export function HowTo() {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Как начать</h2>

      <p className={styles.note}>
        Обработка идёт внутри Telegram-бота — на сайте файлы загружать не нужно.
      </p>

      <ol className={styles.steps}>
        {STEPS.map((step, i) => (
          <li
            key={step.num}
            className={styles.step}
            style={{ animationDelay: `${0.15 * i + 0.3}s` }}
          >
            <div className={styles.top}>
              <span className={styles.num}>{step.num}</span>
              <span className={styles.icon} aria-hidden="true">
                {step.icon}
              </span>
            </div>
            <h3 className={styles.stepTitle}>{step.title}</h3>
            <p className={styles.stepText}>{step.text}</p>
          </li>
        ))}
      </ol>

      <a className={styles.link} href={LINKS.bot} target="_blank" rel="noopener noreferrer">
        <span className={styles.label}>Открыть @vocal_cut_bot</span>
        <span className={styles.arrow} aria-hidden="true">→</span>
      </a>
    </section>
  );
}
